export default (theme: any) => ({
    control: (base, state) => ({
        ...base,
        minHeight: '46px',
        backgroundColor: state.isDisabled ?
            'rgba(239, 239, 239, .3)'
            : 'inherit',
        borderColor: state.isFocused ?
            (theme?.app?.clientTheme.colors.primaryColor || '#375073')
            : (theme?.app?.applicationColors.enumColors.greyLighter || 'hsl(0, 0%, 80%)'),
        boxShadow: state.isFocused ?
            `0 0 0 1px ${theme?.app?.clientTheme.colors.primaryColor || '#375073'}`
            : 'inherit',
        '&:hover': {
            borderColor: state.isFocused ?
                (theme?.app?.clientTheme.colors.primaryColorDark || '#0A2240')
                : 'inherit'
        }
    }),
    option: (base, state) => ({
        ...base,
        color: state.isSelected ?
            (theme?.app?.applicationColors.enumColors.white || '#FFFFFF')
            : (theme?.app?.applicationColors.fontColor || '#202020'),
        backgroundColor: state.isSelected ?
            (theme?.app?.clientTheme.colors.primaryColor || '#375073')
            : 'transparent',
        '&:hover': {
            backgroundColor: state.isSelected ?
                (theme?.app?.clientTheme.colors.primaryColor || '#375073')
                : (theme?.app?.clientTheme.colors.primaryColorLight || '#009BDF')
        }
    }),
    indicatorContainer: (base) => ({
        ...base,
        padding: '2px'
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none'
    })
});